<script>
import OrdersTable from "./Table.vue";
import ReportsTable from "./Report.vue";
import OrderBulkActionForm from "./Form/BulkAction";
import DateField from "../Utility/Forms/InputFields/DateField.vue";
import GetEntitiesByForeignKeyId from "../AAA_TO_REFACTOR/GetEntitiesByForeignKeyId.vue";
import PostLink from "../Utility/Buttons/PostLink.vue";

export default {
    components: {
        OrdersTable,
        ReportsTable,
        OrderBulkActionForm,
        DateField,
        GetEntitiesByForeignKeyId,
        PostLink,
    },

    props: {
        initial: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            q: '', //The free string query i.e. name
            from_date: '',
            to_date: '',
            bulk: [], //The list of participant IDs when using the bulk search function
            order_status: [],
            product_id: [],
            discount_code_id: [],
            occasion_id: [],
            queryString: '', //The calculated query string
            selectedIds: [],
            bulkMode: false,
            rows: 0, //The count of rows
            inViewIds: [] //The list of IDs
        }
    },
    mounted() {
        this.setDataFromQuery()
    },
    methods: {
        deleteQueryParam(searchParams, key) {
            searchParams.delete(key);

            if (Array.isArray(this[key])) {
                for (let i = 0; i <= 200; i++) { //200 - currently on admin/participant/occasions/XXX we add registration_category[0]=1231&registration_category[1]=XX.....
                    let queryKey = key + '[' + i + ']';
                    searchParams.delete(queryKey);
                }
            }

            return searchParams;
        },
        uploadValues(event) {
            let file = event.target.files[0];
            let reader = new FileReader();
            reader.readAsText(file);
            reader.onload = (evt) => {
                let result = evt.target.result.split("\n");
                //TODO - Clean the string here!
                this.bulk = result;
            };
            this.$refs.bulkupload.value = null;
        },
        setDataFromQuery() { //Used when the page is first loaded to set the inital query from the URL query string
            let urlComponents = (this.parseQuery(decodeURIComponent(this.initial)));

            Object.keys(urlComponents).map((key, item) => {
                let value = urlComponents[key];
                if (key.includes('product_id')) {
                    this.product_id.push(value);
                } else if (key.includes('order_status')) {
                    this.order_status.push(value);
                } else if (key.includes('discount_code_id')) {
                    this.discount_code_id.push(value);
                } else if (key.includes('occasion_id')) {
                    this.occasion_id.push(value);
                } else if (key.includes('from_date')) {
                    Object.assign(this, {['from_date']: value});
                } else if (key.includes('to_date')) {
                    Object.assign(this, {['to_date']: value});
                }
            });
        },
        updated(payload) { //When the table is updated after the search filter changes
            this.inViewIds = payload.inViewIds;
            this.rows = payload.rows;
        },
        selectAllIds(ids) { //Select all ID's in view
            this.selectedIds = ids;
        },
        clearSelectedIds() { //Clear the selected ID's
            this.selectedIds = [];
        },
        parseQuery(queryString) {
            var params = {}, queries, temp, i, l;

            // Split into key/value pairs
            queries = queryString.split("&");

            // Convert the array of strings into an object
            for (i = 0, l = queries.length; i < l; i++) {
                temp = queries[i].split('=');
                params[temp[0]] = temp[1];
            }

            return params;
        },
        buildQuery(field) {
            let searchParams = new URLSearchParams(window.location.search)
            searchParams = this.deleteQueryParam(searchParams, field);
            let currentQuery = window.location.pathname + '?' + searchParams.toString();

            if (Array.isArray(this[field])) {
                this[field].forEach((status, index) => {
                    currentQuery += `&${field}[${index}]=${status}`
                })
            } else {
                currentQuery += `&${field}=${this[field]}`
            }

            history.replaceState({}, null, currentQuery);
            searchParams = new URLSearchParams(window.location.search)
            this.queryString = searchParams.toString();
        }
    },
    watch: {
        bulkMode(newVal, oldVal) {
            this.query = '';
            this.selectedIds = [];

            if ((newVal === false)) {
                this.buildQuery('q');
                this.bulk = [];
            }
        },
        q() {
            this.buildQuery('q');
        },
        discount_code_id() {
            this.buildQuery('discount_code_id');
        },
        occasion_id() {
            this.buildQuery('occasion_id');
        },
        product_id(newVal, oldVal) {
            this.$nextTick(() => {
                this.buildQuery('product_id');
            })
        },
        order_status() {
            this.buildQuery('order_status');
        },
        from_date() {
            this.buildQuery(`from_date`);
        },
        to_date() {
            this.buildQuery(`to_date`);
        },
        bulk() {

            if (!this.bulk.length) {
                return;
            }

            let currentQuery = window.location.pathname + '?';

            this.bulk.forEach((status, index) => {
                currentQuery += `&ids[${index}]=${status}`
            })

            this.queryString = currentQuery;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Orders/TableContainer.vue